import { useSyncExternalStore } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import { FirstTrackerMain, SignIn, SignUp, Trackers,
    NewTrackerPage, Settings, Support, CampaignOverview, Insights, SignUpOrgUser, VerifyMainUserEmail, SelectPlan, InviteUser,
EditTrackerPage, ChangePassword, ResetPassword, ActualResetPassword, AdminAddUser, AdminCves, InvitePage, AccountSummary } from '../pages/index'
import { hasAuthToken, subscribeToAuthChanges } from '../services/auth'

const legacyRouteRedirects = [
    ['/FirstTrackerMain', '/first-tracker'],
    ['/NewTrackerPage', '/new-tracker'],
    ['/SignIn', '/signin'],
    ['/Trackers', '/trackers'],
    ['/AccountSummary', '/account-summary'],
    ['/Settings', '/settings'],
    ['/Support', '/support'],
    ['/CampaignOverview/:campaignId', '/campaign-overview/:campaignId'],
    ['/Insights', '/insights'],
    ['/SignUpOrgUser', '/signup-org-user'],
    ['/VerifyMainUserEmail', '/verify-main-user-email'],
    ['/SelectPlan', '/select-plan'],
    ['/InviteUser', '/invite-user'],
    ['/Invite', '/invite'],
    ['/AdminAddUser', '/admin-add-user'],
    ['/AdminCves', '/admin-cves'],
    ['/EditTrackerPage', '/edit-tracker'],
    ['/ChangePassword', '/change-password'],
    ['/ResetPassword', '/reset-password'],
    ['/ActualResetPassword', '/actual-reset-password'],
    ['/actualresetpassword', '/actual-reset-password'],
]

const LegacyRedirect = ({ to }) => {
    const location = useLocation()
    return <Navigate to={`${to}${location.search}${location.hash}`} replace />
}

const ProtectedRoute = ({ children }) => {
    const isAuthenticated = useSyncExternalStore(
        subscribeToAuthChanges,
        hasAuthToken,
        hasAuthToken
    )

    if (!isAuthenticated) {
        return <Navigate to="/signin" replace />
    }

    return children
}

const Routing = () => {
    return (
        <Routes>
            <Route path='/' element={<SignUp />} />
            {legacyRouteRedirects.map(([from, to]) => (
                <Route caseSensitive key={from} path={from} element={<LegacyRedirect to={to} />} />
            ))}
            <Route path='*' element={ <Navigate to={{pathname: "/"}} /> } />
            <Route path='/first-tracker' element={<ProtectedRoute><FirstTrackerMain /></ProtectedRoute>} />
            <Route path='/new-tracker' element={<ProtectedRoute><NewTrackerPage /></ProtectedRoute>} />
            <Route path='/signin' element={<SignIn />} />
            <Route path='/trackers' element={<ProtectedRoute><Trackers /></ProtectedRoute>} />
            <Route path='/account-summary' element={<ProtectedRoute><AccountSummary /></ProtectedRoute>} />
            <Route path='/settings' element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path='/support' element={<ProtectedRoute><Support /></ProtectedRoute>} />
            <Route path='/campaign-overview/:campaignId' element={<ProtectedRoute><CampaignOverview /></ProtectedRoute>} />
            <Route path='/insights' element={<ProtectedRoute><Insights /></ProtectedRoute>} />
            <Route path='/signup-org-user' element={<SignUpOrgUser />} />
            <Route path='/signuporguser' element={<SignUpOrgUser />} />
            <Route path='/verify-main-user-email' element={<VerifyMainUserEmail />} />
            <Route path='/select-plan' element={<ProtectedRoute><SelectPlan /></ProtectedRoute>} />
            <Route path='/invite-user' element={<ProtectedRoute><InviteUser /></ProtectedRoute>} />
            <Route path='/invite' element={<InvitePage />} />
            <Route path='/admin-add-user' element={<ProtectedRoute><AdminAddUser /></ProtectedRoute>} />
            <Route path='/admin-cves' element={<ProtectedRoute><AdminCves /></ProtectedRoute>} />
            <Route path='/edit-tracker' element={<ProtectedRoute><EditTrackerPage /></ProtectedRoute>} />
            <Route path='/change-password' element={<ProtectedRoute><ChangePassword /></ProtectedRoute>} />
            <Route path='/reset-password' element={<ResetPassword />} />
            <Route path="/actual-reset-password" element={<ActualResetPassword />} />
        </Routes>
    )
}

export default Routing
